import { formatImpact, type ImpactLike } from './impact'
import { formatEventWindowUTC } from '../../lib/time'
import { ImpactCallout } from './ImpactCallout'
import { TimeframeCallout } from './TimeframeCallout'

export interface InsightMetaBandProps {
  timeframeStart?: string
  timeframeEnd?: string
  impact?: ImpactLike
  /** Override the impact callout label (e.g. agent-specific wording). */
  impactLabel?: string
}

/**
 * Scannable header band pairing the Timeframe ("when", AXI-4260) and Impact
 * ("how much", AXI-4262) callouts. Side-by-side when both are present,
 * full-width when only one is, and nothing when neither is — so the operator's
 * eye lands on the two most actionable facts before the prose.
 */
export function InsightMetaBand({
  timeframeStart,
  timeframeEnd,
  impact,
  impactLabel
}: InsightMetaBandProps) {
  const hasTimeframe = formatEventWindowUTC(timeframeStart, timeframeEnd) !== ''
  const hasImpact = formatImpact(impact) !== ''
  if (!hasTimeframe && !hasImpact) return null
  if (hasTimeframe && hasImpact) {
    return (
      <div className="grid gap-3 sm:grid-cols-2">
        <TimeframeCallout start={timeframeStart} end={timeframeEnd} />
        <ImpactCallout impact={impact} label={impactLabel} />
      </div>
    )
  }
  return hasTimeframe ? (
    <TimeframeCallout start={timeframeStart} end={timeframeEnd} />
  ) : (
    <ImpactCallout impact={impact} label={impactLabel} />
  )
}
